import { createI18n } from '@learnforge/i18n';
import { locales, type CalcKey } from './locales';

export const i18n = createI18n<CalcKey>({
  gameId: 'calculus',
  locales,
});
